import React, { useState, useCallback } from 'react';
import HeroBackground from './components/Hero/HeroBackground';
import Hero from './components/Hero/Hero';
import Credibility from './components/Sections/Credibility';
import HowItWorks from './components/Sections/HowItWorks';
import Pricing from './components/Sections/Pricing';
import Terms from './components/Sections/Terms';
import CTA from './components/Sections/CTA';
import Footer from './components/Sections/Footer';

function App() {
  const [activeVideo, setActiveVideo] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  // Lifted state for the unified contact form behavior
  const [contactSubject, setContactSubject] = useState('');
  const [isContactOpen, setIsContactOpen] = useState(false);

  const handleVideoChange = useCallback((index) => {
    if (activeVideo === index || isTransitioning) return;
    setActiveVideo(index);
    setIsTransitioning(true);
    
    setTimeout(() => {
      setIsTransitioning(false);
    }, 1000); // Matches CSS crossfade duration
  }, [activeVideo, isTransitioning]);

  const handleOpenContact = useCallback((brand) => {
    const brandText = brand ? brand : 'my brand';
    setContactSubject(`About my brand '${brandText}'`);
    setIsContactOpen(true);
    
    // Slight delay to ensure the form expands before scrolling
    setTimeout(() => {
      document.getElementById('cta')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }, []);

  return (
    <main className="w-full min-h-screen text-white selection:bg-white/30 font-sans bg-black">
      {/* Fixed Ambient Cinematic World */}
      <HeroBackground activeVideo={activeVideo} />

      {/* Scrolling Content Overlay */}
      <div className="relative z-10 w-full">
        <Hero 
          activeVideo={activeVideo} 
          onVideoChange={handleVideoChange} 
          onOpenContact={handleOpenContact}
        />
        
        {/* Dark overlay specifically for sections below the hero to let the video bleed through softly */}
        <div className="bg-black/70 backdrop-blur-md">
          <Credibility />
          <HowItWorks />
          <Pricing />
          <Terms />
          <CTA 
            contactSubject={contactSubject}
            setContactSubject={setContactSubject}
            isContactOpen={isContactOpen}
            setIsContactOpen={setIsContactOpen}
          />
          <Footer />
        </div>
      </div>
    </main>
  );
}

export default App;